import { type GroupChannel } from "@sendbird/chat/groupChannel";
import { Shift } from "@src/lib/interface";

export const ActionType = {
  SET_CHANNELS: "SET_CHANNELS",
  UPDATE_CHANNEL: "UPDATE_CHANNEL",
  SET_UPCOMING_SHIFTS: "SET_UPCOMING_SHIFTS",
};

export interface LegacyChatChannelMetadata {
  facilityId?: string;
  facilityName?: string;
  facilityType?: string;
  hcpName?: string;
  lastBooked?: string;
  placementCandidateAccessId?: string;
  placementId?: string;
  placementTitle?: string;
}

export interface LegacyChatChannel extends GroupChannel {
  shift: Shift;
  metadata: LegacyChatChannelMetadata;
}

export interface ChatStore {
  channels: LegacyChatChannel[];
  upcomingShifts: { [key: string]: Shift };
}
